import { render, staticRenderFns } from "./DropdownOption.vue?vue&type=template&id=01cb94a8&scoped=true&"
import script from "./DropdownOption.vue?vue&type=script&lang=js&"
export * from "./DropdownOption.vue?vue&type=script&lang=js&"
import style0 from "./DropdownOption.vue?vue&type=style&index=0&id=01cb94a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cb94a8",
  null
  
)

export default component.exports